import  React, { useState, useRef, useEffect  } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../assest/icons";
import { ToastContainer, toast } from "react-toastify";
import LeftSideLogin from "./leftsidelogin";
import { logger } from '../utils/logger';
import { useGoogleLogin } from "@react-oauth/google";
import { createAdminLog, updateUser } from '../services/firestore';
import { signInWithCustomToken } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase.config';
import { fetchWithAppCheck } from '../utils/fetchWithAppCheck';
import Modal from 'react-modal';
import ConsentNotice from './consenttext';
import { isValidNewPassword } from '../utils/passwordValidation';


const Switch = () => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // HIPAA: Remove any insecure saved passwords from previous sessions
    localStorage.removeItem('savedPassword');
    const savedEmail = localStorage.getItem('savedEmail');
    if (savedEmail) {
      setIsChecked(true);
    }
  }, []);

  const handleChange = () => {
    setIsChecked(!isChecked);
    if (isChecked) {
      localStorage.removeItem('savedEmail');
    }
  };

  return (
    <div className="switch-container d-flex">
      <label>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
          className="switch"
        />
        <div className="switch-slider">
          <div className="switch-knob"></div>
        </div>
      </label>
      <span style={{ marginLeft: "5px" }}>Remember my email</span>
    </div>
  );
};



function LoginScreen() {
  const navigate = useNavigate();

  // If already logged in, redirect to dashboard
  useEffect(() => {
    const userProfile = localStorage.getItem('UserProfile');
    const loginStatus = localStorage.getItem('UserLoginStatus');
    if (userProfile && loginStatus === 'true') {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const [email, setEmail] = useState(localStorage.getItem('savedEmail') || '');
  const [showAccessToken, setAccessToken] = useState('');
  const [UserLoginStatus, setUserLoginStatus] = useState('');
  const [password, setPassword] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [GShowLoader, setGShowLoader] = useState(false);
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('savedEmail'));
  const [UserId, setUserId] = useState('');  
  const [UserData, setUserData] = useState([]);
  const [passwordType, setPasswordType] = useState("password");
  const [showConsentModal, setShowConsentModal] = useState(false);
  const openConsentModal = () => setShowConsentModal(true);
  const closeConsentModal = () => setShowConsentModal(false);

  const handleClickPassword = (event) => { 
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const handlePasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
    setErrors('');
};
// const handleEmailChange = (event) => {
//   const { value } = event.target;
//   setEmail(value); 

//   // Simple regex for email validation
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   setIsValid(emailRegex.test(value));
//   setErrors('');
// };

// const handleEmailChange = (e) => {
//   const value = e.target.value;
//   const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   // if (emailRegex.test(value)) {
//   //   setErrors('');
//   // } else { 
//   //   setErrors('Invalid email format');
//   // }
//   // console.log(errors)
//   // setEmail(value);
//    // Remove characters that are not alphanumeric, hyphens, dots, or @
//    // let value1 = value.replace(/[^a-zA-Z0-9.-@]/g, '');
  
//     setEmail(value);

//     // Validate the email using regex
//     if (emailRegex.test(value)) {
//       setIsValid(true);
//       setErrors({ email: '' });
//     } else {
//       setIsValid(false);
//       setErrors({ email: 'Invalid email format. Only alphanumeric characters, hyphens, underscores, dots, and @ are allowed.' });
//     }
 
// };
 // Regex pattern allowing alphanumeric characters, hyphens, underscores, dots, and @
 const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

 const handleEmailChange = (e) => {
   const value = e.target.value;
   setEmail(value);

  // Validate the email using regex
  if (emailRegex.test(value)) {
    setIsValid(true);
    setErrors({ email: '' });
  } else {
    setIsValid(false);
    setErrors({ email: 'Enter a valid email' });
  }
};
 
  useEffect(() => {
    // Check if there is a stored rememberMe preference
    const storedRememberMe = localStorage.getItem('rememberMe');
    if (storedRememberMe) {
        setRememberMe(JSON.parse(storedRememberMe));
    }
}, []);

  const handleResetForm= () => { 
    setEmail(''); 
    setPassword(''); 
    setErrors('');
  };
  const nav = useNavigate();
  const routeChange = () =>{  
    nav("/dashboard", { state:UserData, replace: true });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Simple form validation
    let formErrors = {};
    if (!email.trim()) {
      formErrors.email = 'Please enter your email';
    }
    if (!password.trim()) {
        formErrors.password = 'Please enter your password';
   }
    if (Object.keys(formErrors).length > 0) {
        setErrors(formErrors);
        return;
    }
    
    setShowLoader(true);

    try {
      // Server-side password verification — bcrypt, lockout, and Google-only check
      // are all handled inside the verifyPatientPassword Cloud Function.
      const functionsBase = process.env.REACT_APP_FUNCTIONS_BASE_URL
        || 'https://us-central1-aigicare-prod.cloudfunctions.net';

      const loginRes = await fetchWithAppCheck(`${functionsBase}/verifyPatientPassword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });
      const loginData = await loginRes.json();

      if (!loginRes.ok) {
        toast.error(loginData.message || 'Invalid email or password', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setShowLoader(false);
        return;
      }

      // Establish Firebase Auth session using the Custom Token from the CF
      await signInWithCustomToken(auth, loginData.customToken);

      // Read the user document (auth is now populated; Firestore rules will pass)
      const userSnap = await getDoc(doc(db, 'users', loginData.userId));
      const rawUser = userSnap.exists() ? { id: loginData.userId, ...userSnap.data() } : { id: loginData.userId };

      // Check if account is inactive
      if (rawUser.accountStatus === 'inactive') {
        toast.error('Your account has been deactivated. Please contact admin.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setShowLoader(false);
        return;
      }

      // Update timezone (fire-and-forget)
      updateUser(loginData.userId, { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }).catch(() => {});

      // Exclude sensitive fields from localStorage
      const { password: _pw, password_history: _ph, reset_token: _rt, reset_token_expires_at: _rte, failed_login_attempts: _fla, locked_until: _lu, ...safeUser } = rawUser;
      const userData = { ...safeUser, user_id: loginData.userId, status: 'success' };

      toast.success('User Signin successfully!', { position: toast.POSITION.TOP_RIGHT });
      setUserData(userData);

      localStorage.setItem('UserId', JSON.stringify(loginData.userId));
      localStorage.setItem('UserLoginStatus', JSON.stringify(true));
      if (rememberMe) {
        localStorage.setItem('savedEmail', email);
      } else {
        localStorage.removeItem('savedEmail');
      }
      localStorage.setItem('UserProfile', JSON.stringify(userData));
      sessionStorage.setItem('aigi_session_alive', 'true');

      createAdminLog({ action: 'patient_login', user_email: email, ip_info: 'client' }).catch(() => {});

      setShowLoader(false);
      handleResetForm();
      routeChange();

    } catch (error) {
      logger.error('Error during login:', error);
      toast.error(error.message || 'An error occurred during login. Please try again.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }
  };
const isValidEmail = (email) => {
  // Regular expression to validate email format
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
//Google Sign up & Sign in Fucntion

const googleLogin = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    setAccessToken(tokenResponse.access_token);
    checkGoogleLogin(tokenResponse.access_token)
  },
  onError: (errorResponse) => {
    // Error handled silently
  },
});
const checkGoogleLogin = async (accessToken) => {
  setGShowLoader(true);

  try {
    const functionsBase = process.env.REACT_APP_FUNCTIONS_BASE_URL
      || 'https://us-central1-aigicare-prod.cloudfunctions.net';

    // Server-side Google login — verifies Google token, looks up user,
    // issues Firebase Custom Token. No password hashes ever reach the browser.
    const loginRes = await fetchWithAppCheck(`${functionsBase}/googlePatientLogin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        googleAccessToken: accessToken,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }),
    });
    const loginData = await loginRes.json();

    if (loginRes.status === 404) {
      toast.info('No account found. Please sign up first.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setGShowLoader(false);
      nav('/signup');
      return;
    }

    if (!loginRes.ok) {
      toast.error(loginData.message || 'An error occurred. Please try again.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setGShowLoader(false);
      return;
    }

    // Establish Firebase Auth session using Custom Token from CF
    await signInWithCustomToken(auth, loginData.customToken);

    toast.success("Login successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });

    const userData = { ...loginData.userData, status: 'success' };
    setUserData(userData);

    // Save to localStorage (CF already stripped sensitive fields)
    localStorage.setItem('UserProfile', JSON.stringify(userData));
    localStorage.setItem('UserId', JSON.stringify(loginData.userData.user_id));
    localStorage.setItem('UserLoginStatus', JSON.stringify(true));
    sessionStorage.setItem('aigi_session_alive', 'true');

    setGShowLoader(false);
    nav("/dashboard", { replace: true });

  } catch (error) {
    logger.error('Error during Google login:', error);
    toast.error(error.message || 'An error occurred. Please try again.', {
      position: toast.POSITION.TOP_RIGHT,
    });
    setGShowLoader(false);
  }
};

// Commented out - these are test functions not used in production
// const handleUserRemove1s = async () => {
//   const data = '664e171d68a60019dd923e02';
// };

// const handleUserRemove = async () => {
//   const userIdRemove = '674f100b68a600268ec843e7';
// };

  return (
    <div>
      <div className='container-fluid p-0 bgImageUrl'>
       
        <div className='container p-0 contentBody loginScreen'>

       <LeftSideLogin />

          <div className="col-lg-5 d-inline-block  position-relative">
            <div className="loginBoxDiv">
            <h3  className="titleDespTxt">Sign in to AIGI Care</h3>
            <form  onSubmit={handleSubmit} autoComplete="on">
            
                              
           <div className='inputGroupDiv'> 
                <div className="inputTxtBox registerInputDiv">
                   <img src={Icons[0].mailImg} className="logoImg" alt="" />
                    <input type="email" value={email} placeholder="Email id" autoComplete="email"
                     onChange={handleEmailChange}
                     style={{
                      borderColor: isValid ? 'black' : 'red'
                    }}
                    />  
                 
                </div>
                {errors.email && <span  className="errorTxt" >{errors.email}</span>}
          </div>
            
          <div className='inputGroupDiv'> 
                <div className="inputTxtBox registerInputDiv ">
                   <img src={Icons[0].lockedImg} className="logoImg" alt="" />
                   
                   <input type={passwordType}  value={password} placeholder="Password" autoComplete="current-password" onChange={handlePasswordChange}/>
                    <label className='eyePwdIcon' onClick={handleClickPassword}>  
                      <img src={passwordType === "password" ? ( Icons[0].closeEye  ) : ( Icons[0].opneEye  )} className="logoImg" alt="" />
                    </label>                
                </div>
                {errors.password && <span  className="errorTxt" >{errors.password}</span>}
          </div>

             
              <div className="optDivBox d-flex justify-content-between">
               
                
                  {/* <input type="checkbox" id="switch" checked={rememberMe}  onChange={(e) => setRememberMe(e.target.checked)}/><label for="switch">Toggle</label> */}
                  <Switch />  
                 <span className="forgotPwd"> <Link to="/forgotpassword">Forgot Password?</Link></span> 
              </div>
              {ShowLoader ? (<>
                      <button  className="signInBtn" > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button className="signInBtn" type="submit" >Sign In</button>
                    </>)}
            
              <span className="otherSignInOpt">
                <p>or sign in with</p>
                <ul>
                  <li className="w-100" onClick={() => googleLogin()}>
                    <img src={Icons[0].gmailImg} className="" alt="" />
                    {GShowLoader ? (<>
                     Continue with Google <div className="spinner-border " role="status">  </div> 
                     
                    </>):(<>
                      Continue with Google
                    </>)}
                  </li>
                

                </ul>
              </span>
              <div className="signupDiv">
                    Don't have an account  <Link to="/signup">Sign up</Link>
              </div>

              {/* Privacy Policy & Terms */}
              <div style={{ marginTop: '14px', fontSize: '12px', color: '#666', textAlign: 'center' }}>
                By signing in, you agree to our{' '}
                <span
                  style={{ color: '#0d6efd', cursor: 'pointer', fontWeight: '600' }}
                  onClick={() => openConsentModal()}
                >
                  Privacy Policy &amp; Terms
                </span>
              </div>

            </form>
            </div>
          </div>

        </div>

      </div>

      {/* Consent / Privacy Policy Modal */}
      <Modal
        className="consentCheckModal modalViewAllMain"
        isOpen={showConsentModal}
        onRequestClose={closeConsentModal}
        contentLabel="Privacy Policy & Terms"
      >
        <div className="innerModalDiv overflow-hidden">
          <div style={{ padding: '10px 16px 0', borderBottom: '1px solid #dee2e6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h5 style={{ margin: 0, fontWeight: '700', color: '#024C9C' }}>Privacy Policy &amp; Terms</h5>
            <span onClick={closeConsentModal} style={{ cursor: 'pointer', fontSize: '22px', lineHeight: 1, color: '#666' }}>&times;</span>
          </div>
          <ConsentNotice onAgree={closeConsentModal} onDecline={closeConsentModal} />
        </div>
      </Modal>

    </div>
  );
}

export default LoginScreen;
